import React from 'react';

import { siteLinkData } from 'javascripts/shared/utils/site_link_data';
import { CdnImageUtils } from 'shared/utils/cdn_image_utils';

import { AssetImg } from 'javascripts/components/asset_img';

import AppStoreImage from 'images/apple-store-badge';
import PlayStoreImage from 'images/google-play-badge';
import AlexaImage from 'images/alexa-store-badge';

import styles from 'stylesheets/components/audiobook/how_to_listen_section';

export function HowToListenSection() {
  function renderHeader(img, title) {
    return (
      <>
        <img className={styles.headerImage} src={CdnImageUtils.getOptimizedImage(img)} alt='' />
        <div className={styles.header}>{title}</div>
      </>
    );
  }

  function renderSupportLink(text, linkText, href) {
    return (
      <div className={styles.havingTrouble}>
        {text}{' '}
        <a className={styles.link} href={href}>
          {linkText}
        </a>
      </div>
    );
  }

  function renderAppSection() {
    return (
      <div className={styles.listenSection}>
        {renderHeader('audiobook_page/phone', 'On Your Smartphone or Tablet')}
        <div className={styles.description}>
          Once you&apos;ve purchased an audiobook, you can listen to your audiobooks using the Chirp app, available for
          Android and Apple iOS devices. You can stream directly or download for later!
        </div>
        <div className={styles.appLinks}>
          <a
            className={styles.appLink}
            href={siteLinkData.getPath('appleAppStore')}
            aria-label='Download on the App Store'
          >
            <AssetImg src={AppStoreImage} attrs={{ alt: '', width: '100%' }} />
          </a>
          <a
            className={styles.appLink}
            href={siteLinkData.getPath('googlePlayStore')}
            aria-label='Get it on Google Play'
          >
            <AssetImg src={PlayStoreImage} attrs={{ alt: '', width: '100%' }} />
          </a>
        </div>
        {renderSupportLink(
          'Having trouble using the app?',
          'Check out these FAQs',
          'https://support.chirpbooks.com/article-categories/listening-with-chirp/',
        )}
      </div>
    );
  }

  function renderAlexaSection() {
    return (
      <div className={styles.listenSection}>
        {renderHeader('audiobook_page/alexa', 'Alexa Devices')}
        <div className={styles.description}>
          It&apos;s easy to listen to your Chirp audiobooks on your Alexa-enabled devices! To get started, enable the
          Chirp skill on your Alexa device. Once enabled, follow the steps to link your Chirp account.
        </div>
        <a href={siteLinkData.getPath('alexaAppStore')} aria-label='Get from Alexa'>
          <AssetImg src={AlexaImage} attrs={{ alt: '', width: '100px' }} />
        </a>
        {renderSupportLink(
          'Having trouble using Alexa?',
          'Check out these FAQs',
          'https://support.chirpbooks.com/knowledge-base/can-i-listen-using-alexa-how-do-i-use-chirp-on-alexa/',
        )}
      </div>
    );
  }

  function renderComputerSection() {
    return (
      <div className={styles.listenSection}>
        {renderHeader('audiobook_page/laptop', 'On Your Computer')}
        <div className={styles.description}>
          You can also stream audiobooks in your web browser on a Mac or PC, as well as other devices, from{' '}
          <a className={styles.link} href={siteLinkData.getPath('library')}>
            your Library.
          </a>
        </div>
        {renderSupportLink(
          'Having trouble using the site?',
          'Visit our Support Center',
          'https://support.chirpbooks.com/article-categories/listening-with-chirp/',
        )}
      </div>
    );
  }

  function renderHelpSection() {
    return (
      <div className={styles.listenSection}>
        {renderHeader('audiobook_page/contact', "We're Always Here to Help")}
        <div className={styles.description}>
          If you are having issues listening to your audiobooks or making purchases, please{' '}
          <a className={styles.link} href='/contact'>
            contact us.
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.howToListenSection}>
      <div className={styles.content}>
        {renderAppSection()}
        {renderAlexaSection()}
        {renderComputerSection()}
        {renderHelpSection()}
      </div>
    </div>
  );
}
